import {getApiBase} from '../../config/apiBase';
import buildHeaders from './fetchHeaders';

/** Same-origin `/api` in local dev (CRA proxy → JVM); override with REACT_APP_API_URL. */
export const API_BASE = getApiBase().replace(/\/$/, '') || '/api';


export async function createReport(userId) {
    const response = await fetch(`${API_BASE}/reports/create`, {
        method: 'POST',
        headers: buildHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }),
        body: JSON.stringify({userId}),
    });

    if (!response.ok) {
        let message = 'Failed to create report';
        try {
            const errText = await response.text();
            if (errText) message += `: ${errText}`;
        } catch (_) {
        }
        throw new Error(message);
    }

    return await response.json();
}

export async function getReportsByUser(userId) {
    if (!userId) return [];
    const response = await fetch(`${API_BASE}/reports?authorUid=${encodeURIComponent(userId)}`, {
        method: 'GET',
        headers: buildHeaders({
            'Accept': 'application/json',
        }),
    });

    if (!response.ok) {
        let message = 'Failed to fetch reports';
        try {
            const errText = await response.text();
            if (errText) message += `: ${errText}`;
        } catch (_) {
        }
        throw new Error(message);
    }

    return await response.json();
}

export async function getReportById(reportId) {
    const response = await fetch(`${API_BASE}/reports/${reportId}`, {
        method: 'GET',
        headers: buildHeaders({
            'Accept': 'application/json',
        }),
    });

    if (!response.ok) {
        let message = 'Failed to fetch report';
        try {
            const errText = await response.text();
            if (errText) message += `: ${errText}`;
        } catch (_) {
        }
        throw new Error(message);
    }

    return await response.json();
}

export async function apiUpdateReport(reportId, updates) {
    const response = await fetch(`${API_BASE}/reports/update`, {
        method: 'PUT',
        headers: buildHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }),
        body: JSON.stringify({reportId, ...updates}),
    });

    if (!response.ok) {
        let message = 'Failed to update report';
        try {
            const errText = await response.text();
            if (errText) message += `: ${errText}`;
        } catch (_) {
        }
        throw new Error(message);
    }

    return await response.json();
}

/**
 * Save a snapshot of the report content (fire-and-forget).
 * This is called automatically when a report is saved.
 * The API returns 202 Accepted immediately and processes the snapshot asynchronously.
 *
 * @param {string} reportId - The report ID
 * @param {string} userId - The user ID
 * @param {string} title - The report title
 * @param {object} content - The TipTap JSON content
 * @param {string} status - The report status
 * @returns {Promise<void>} Resolves when the request is sent (doesn't wait for processing)
 */
export async function saveSnapshot(reportId, userId, title, content, status = 'draft') {
    try {
        console.log('[SNAPSHOT API] Sending request to:', `${API_BASE}/snapshots/report-content`);
        const response = await fetch(`${API_BASE}/snapshots/report-content`, {
            method: 'POST',
            headers: buildHeaders({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify({
                reportId,
                userId,
                title,
                content,
                status,
                snapshotType: 'auto',
            }),
        });
        console.log('[SNAPSHOT API] Response:', response.status, response.statusText);
        if (!response.ok) {
            const errorText = await response.text();
            console.warn('[SNAPSHOT API] Error response:', errorText);
        }
        // Fire-and-forget: don't throw errors, just log them
    } catch (error) {
        console.warn('[SNAPSHOT API] Failed to save snapshot (non-critical):', error);
    }
}
